<template>
  <dialog class="z-50 addon-dialog" name="addonselector" height="auto" id="addon-dialog" >
    <div class="dialog__content">
      <h3 class="headline-extras">Wähle Deine Extras</h3>
      <form v-if="hasProductRules" class="w-full" >
        <div v-for="productrule in productrules" :key="productrule.id" class="md:flex md:items-center mb-6">
          <div class="md:w-1/3">
            <label class="block text-grey-darker font-bold md:text-right mb-1 md:mb-0 pr-4" for="inline-full-name">
              {{ productrule.item_title }}<br />
              <span class="text-xs font-normal">{{ productrule.item_description }}</span>
            </label>
          </div>
          <div class="md:w-2/3">
            <select :ref="'ingredients_' + productrule.id" class="block appearance-none w-full bg-grey-lighter border border-grey-lighter text-grey-darker py-3 px-4 pr-8 rounded" id="grid-state">
              <option value="" v-if="productrule.item_rule == 'optional'">-- ohne --</option>
              <option :value="ingredient.id" :key="ingredient.id" v-for="ingredient in productrule.item_ingredients" :selected="ingredient.id == productrule.item_default">
                {{ ingredient.title }}
                {{ ingredient.price | pricetag | addPlusIfNotNull }}
              </option>
            </select>
          </div>
        </div>
        <div class="md:flex md:items-center">
          <div class="md:w-1/3"></div>
          <div class="md:w-2/3">
            <button @click.prevent="addIngredients" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold py-2 px-4 rounded cursor-pointer" type="button">
              Weiter!
            </button>
          </div>
        </div>
      </form>
    </div>
  </dialog>
</template>

<script>
import endpoints from '../endpoints'
import axios from 'axios'
import _ from 'lodash'
import { mapActions } from 'vuex'
import { openDialog, closeDialog } from '../utils/dialog'

export default {
  name: 'Productrules',

  data () {
    return {
      hostId: window.hostId,
      buildId: null,
      productrules: [],
      errors: [],
      isLoading: false,
      choseIngredients: false
    }
  },

  computed: {
    hasProductRules: function () {
      return (_.size(this.productrules) > 0)
    }
  },

  created () {
    window.eventBus.$on('checkProductrules', basketData => {
      this.buildId = basketData.buildId
      this.productId = basketData.productId
      this.productSize = basketData.productSize

      this.checkProductRules()
    })
  },

  mounted () {
    const dialog = document.getElementById('addon-dialog')

    dialog.addEventListener('close', () => {
      console.log('addon-dialog closed')
      // Only call if not already handled by addIngredients
      if (!this.choseIngredients) {
        this.beforeClose({ params: { choseIngredients: false } })
      }

      // Reset for next time
      this.choseIngredients = false
    })
  },

  methods: {
    ...mapActions([
      'updateBasket',
      'removeProduct'
    ]),

    checkProductRules: function () {
      axios.post(endpoints.productRules, {
        'productId': this.productId,
        'size': this.productSize
      })
        .then(response => {
          if (_.size(response.data) < 1) return false

          this.productrules = response.data
          openDialog('addon-dialog')
        })
        .catch(e => {
          this.errors.push(e)
        })
    },

    addIngredients: function (event) {
      let ingredients = []
      let ingredient = ''

      if (this.isLoading) return

      this.isLoading = true
      event.target.classList.add('loading')

      _.each(this.$refs, function (dropdown) {
        if (typeof dropdown[0] === 'object') {
          ingredient = Number(dropdown[0].value)

          if (ingredient > 0) {
            ingredients.push(ingredient)
          }
        }
      })

      if (_.size(ingredients) > 0) {
        axios.post(endpoints.addIngredients, {
          'buildId': this.buildId,
          'ingredients': ingredients
        }).then(response => {
          // hide the modal, adding data to the before-closed event, so we know that the modal was closed with the intention of adding the product to the basket
          this.choseIngredients = true
          this.beforeClose()
          this.updateBasket()
        })
          .catch(e => {
            this.errors.push(e)
          })
          .finally(() => {
            this.isLoading = false
            event.target.classList.remove('loading')
          })
      } else {
        this.choseIngredients = true
        this.beforeClose()
      }
    },

    /**
     *  check if the modal was closed after the ingredients were chosen or by clicking away
     * @param {object} event the before-close event emitted by the modal component
     * @param {object} event.params the data coming with the before-close event, undefined if the modal was closed by clicking away
     * @param {boolean} event.params.choseIngredients wether the user has chosenIngredients or not
     */
    beforeClose () {
      this.isLoading = false

      // just close if closing happened through clicking the add button
      if (this.choseIngredients) {
        closeDialog('addon-dialog')
        return
      }
      // remove the product again if the modal was closed by clicking away
      this.removeProduct({ basketId: this.buildId })
        .catch((e) => {
          this.errors.push(e)
        })
      closeDialog('addon-dialog')
    }
  }
}
</script>

<style lang="scss" scoped>
  .headline-extras {
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Productrules.vue